import Vue from 'vue'
import Vuex from 'vuex'
import mixins from '@/mixins'
import router from '@/router'
import { getarealistAPI } from '@/api/pubilcapi'
import { getToken, setToken, removeToken } from "@/utils/auth";

import {
  userinfoApi
} from '@/api/mine';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户信息
    user: localStorage.getItem('user') || null,
    // 省市区
    citylist: [],
    // 订单参数缓存
    oredermsg: null

  },
  getters: {
  },
  mutations: {
    setcitylist(state, val) {
      state.citylist = val
    },
    // 用户信息
    setUser(state, data) {
      state.user = data;
      localStorage.setItem('user', data);
    },
    // 订单参数缓存
    setoredermsg(state, val) {
      state.oredermsg = val
    },
    async logout(state) {
      try {
        await Vue.prototype.$confirm('确定退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        Vue.prototype.$message({
          type: 'success',
          message: '退出成功!'
        });
        removeToken();
        state.user = null;
        router.replace('/login');
      } catch (error) {
        // Vue.prototype.$message({
        //   type: 'info',
        //   message: '已取消退出'
        // });
      }
    }
  },
  actions: {
    async getcitylist({ commit, state }) {
      if (state.citylist.length) return
      const res = await getarealistAPI()
      let data = mixins.methods.renameTextTolabel(res.data)
      commit('setcitylist', data)
    },
    // 获取用户信息
    async getUser({
      commit
    }) {
      let res = await userinfoApi();
      if (res.code == 1) {
        commit('setUser', res.data);
      }
    },
  },
  modules: {
  }
})
